// CSS-only animated tech background (subtle particle grid + drifting orbs)
import "./TechBg.css";

export default function TechBg({ density = "normal" }) {
  return (
    <div className="tech-bg pointer-events-none absolute inset-0 overflow-hidden">
      <div className="tech-grid" />
      <div className="orb orb-1" />
      <div className="orb orb-2" />
      <div className="orb orb-3" />
    </div>
  );
}
